import { schema, normalize } from 'normalizr';

export const entity = 'staffShop';
export const entitySchema = new schema.Entity(entity);
export const listNormalizer = result => normalize(result.shops, [entitySchema]);
